module.exports = __webpack_public_path__ + "media/bg/bg-7-0bf4526a.jpg";